// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var DOM$SmartcutsMacros = require("../DOM.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var RadioOrSelectOption$SmartcutsMacros = require("./shared/RadioOrSelectOption.bs.js");
var DomElementIdentifierGenerator$SmartcutsMacros = require("../DomElementIdentifierGenerator.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "options",
                Decco.arrayToJson(RadioOrSelectOption$SmartcutsMacros.t_encode, v.options)
              ],
              [
                "selectedIndex",
                Decco.intToJson(v.selectedIndex)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var options = Decco.arrayFromJson(RadioOrSelectOption$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
  if (options.TAG === /* Ok */0) {
    var selectedIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectedIndex"), null));
    if (selectedIndex.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                options: options._0,
                selectedIndex: selectedIndex._0
              }
            };
    }
    var e = selectedIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".selectedIndex" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = options._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".options" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  return "{options=" + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list($$Array.map(RadioOrSelectOption$SmartcutsMacros.stringify, param.options))) + (", selectedIndex=" + (String(param.selectedIndex) + "}")));
}

var SelectInput = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "label",
                Decco.optionToJson(Decco.stringToJson, v.label)
              ],
              [
                "value",
                t_encode(v.value)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var value = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                value: value._0
              }
            };
    }
    var e = value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".value" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$1(param) {
  return "{label=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.label) + (", value=" + (stringify(param.value) + "}")));
}

var LabeledSelectInputValue = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "domElementIdentifierWithSelector",
                DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
              ],
              [
                "labeledSelectInputValue",
                t_encode$1(v.labeledSelectInputValue)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
  if (domElementIdentifierWithSelector.TAG === /* Ok */0) {
    var labeledSelectInputValue = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledSelectInputValue"), null));
    if (labeledSelectInputValue.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                labeledSelectInputValue: labeledSelectInputValue._0
              }
            };
    }
    var e = labeledSelectInputValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labeledSelectInputValue" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = domElementIdentifierWithSelector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$2(param) {
  return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + ", labeledSelectInputValue}");
}

function fromInputEvent(domElementIdentifierGenerator, inputEvent) {
  var target = inputEvent.target;
  var tagName = target.tagName.toLowerCase();
  if (tagName !== "select") {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected event to target '<select>'");
  }
  var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(target, domElementIdentifierGenerator);
  var label = OptionUtils$SmartcutsMacros.map(DOM$SmartcutsMacros.$$EventTarget.deduceNameOfInput(target), (function (name) {
          return name.replace(/_+/g, " ");
        }));
  var selectElement = Curry._1(DOM$SmartcutsMacros.HtmlSelectElement.fromElement, target);
  var selectedIndex = Curry._1(DOM$SmartcutsMacros.HtmlSelectElement.selectedIndexGet, selectElement);
  var options = $$Array.map(RadioOrSelectOption$SmartcutsMacros.fromDomElement, DOM$SmartcutsMacros.HtmlSelectElement.optionsGet(selectElement));
  var value = {
    options: options,
    selectedIndex: selectedIndex
  };
  var selector = Selector$SmartcutsMacros.forDomEventTarget(target);
  return {
          domElementIdentifierWithSelector: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
          },
          labeledSelectInputValue: {
            label: label,
            value: value
          }
        };
}

var Recording = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2,
  fromInputEvent: fromInputEvent
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "labeledSelectInputValue",
                t_encode$1(v.labeledSelectInputValue)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var labeledSelectInputValue = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledSelectInputValue"), null));
    if (labeledSelectInputValue.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selector: selector._0,
                labeledSelectInputValue: labeledSelectInputValue._0
              }
            };
    }
    var e = labeledSelectInputValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labeledSelectInputValue" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromRecordingCommandValue(param) {
  return {
          selector: param.domElementIdentifierWithSelector.selector,
          labeledSelectInputValue: param.labeledSelectInputValue
        };
}

function updateSelector(f, param) {
  return {
          selector: Curry._1(f, param.selector),
          labeledSelectInputValue: param.labeledSelectInputValue
        };
}

function getInputIdentifier(param) {
  return Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}

function stringify$3(param) {
  return "{selector: " + (StringUtils$SmartcutsMacros.quote(Selector$SmartcutsMacros.stringify(undefined, false, param.selector)) + ", labeledSelectInputValue}");
}

var Authoring = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromRecordingCommandValue: fromRecordingCommandValue,
  updateSelector: updateSelector,
  getInputIdentifier: getInputIdentifier,
  stringify: stringify$3
};

var t_encode$4 = t_encode$3;

var t_decode$4 = t_decode$3;

function selectorGet(param) {
  return [param.selector];
}

function fromAuthoringCommandValue(v) {
  return v;
}

var Playback = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify$3,
  selectorGet: selectorGet,
  fromAuthoringCommandValue: fromAuthoringCommandValue
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function isDynamic(param) {
  return param.dynamic;
}

function fromAuthoringCommandValue$1(param) {
  var originalLabeledValue = param.labeledSelectInputValue;
  return {
          targetLocator: param.selector,
          originalLabeledValue: originalLabeledValue,
          playbackFormLabel: OptionUtils$SmartcutsMacros.withDefault("[Add a label]", originalLabeledValue.label),
          dynamic: false
        };
}

function updateConfigWithAuthoringCommandValue(param, config) {
  return {
          targetLocator: config.targetLocator,
          originalLabeledValue: param.labeledSelectInputValue,
          playbackFormLabel: config.playbackFormLabel,
          dynamic: config.dynamic
        };
}

var AuthoringConfig = {
  isDynamic: isDynamic,
  fromAuthoringCommandValue: fromAuthoringCommandValue$1,
  updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue
};

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "targetLocator",
                Selector$SmartcutsMacros.selector_encode(v.targetLocator)
              ],
              [
                "originalLabeledValue",
                t_encode$1(v.originalLabeledValue)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
  if (targetLocator.TAG === /* Ok */0) {
    var originalLabeledValue = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalLabeledValue"), null));
    if (originalLabeledValue.TAG === /* Ok */0) {
      var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
      if (playbackFormLabel.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  targetLocator: targetLocator._0,
                  originalLabeledValue: originalLabeledValue._0,
                  playbackFormLabel: playbackFormLabel._0
                }
              };
      }
      var e = playbackFormLabel._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".playbackFormLabel" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = originalLabeledValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".originalLabeledValue" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = targetLocator._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".targetLocator" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromAuthoringConfig(param) {
  return {
          targetLocator: param.targetLocator,
          originalLabeledValue: param.originalLabeledValue,
          playbackFormLabel: param.playbackFormLabel
        };
}

var ParamDescriptor = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  fromAuthoringConfig: fromAuthoringConfig
};

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "targetLocator",
                Selector$SmartcutsMacros.selector_encode(v.targetLocator)
              ],
              [
                "labeledValue",
                t_encode$1(v.labeledValue)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
  if (targetLocator.TAG === /* Ok */0) {
    var labeledValue = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledValue"), null));
    if (labeledValue.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                targetLocator: targetLocator._0,
                labeledValue: labeledValue._0
              }
            };
    }
    var e = labeledValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labeledValue" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = targetLocator._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".targetLocator" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$4(param) {
  return "{targetLocator, labeledValue=" + (stringify$1(param.labeledValue) + "}");
}

function fromParamDescriptor(param) {
  return {
          targetLocator: param.targetLocator,
          labeledValue: param.originalLabeledValue
        };
}

function toCommandValueForPlayback(param) {
  return {
          selector: param.targetLocator,
          labeledSelectInputValue: param.labeledValue
        };
}

var PlaybackParamValue = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  stringify: stringify$4,
  fromParamDescriptor: fromParamDescriptor,
  toCommandValueForPlayback: toCommandValueForPlayback
};

exports.SelectInput = SelectInput;
exports.LabeledSelectInputValue = LabeledSelectInputValue;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* DOM-SmartcutsMacros Not a pure module */
